<template>
    <div class="swiper-container">
      <div
        class="swiper-slide"
      >
        <div class="swiper-slide-card">
          <div
            class="card job_con sensors_exposure"
            v-for="(item, index) in urgentJobList"
            :key="index"
            @click="clickJobCard(item, index)"
            sensorsname="JobShortExposure"
            :sensorsdata="buildJobShortExposureParams(item, index)"
          >
            <div
              v-if="componentConfig?.postButtonType == 1"
              :class="[
                'job-checkbox',
                selectedJobIds.length > 0 && selectedJobIds.includes(item.jobId)
                  ? 'selected'
                  : '',
                item.isApply
                  ? 'isApply'
                  : item.isFromXyx || item.isExpire
                  ? 'disabled'
                  : '',
              ]"
              @click.stop="onClickJobCheckbox(item)"
            >
              <span class="circle" :style="{border:`${selectedJobIds.length > 0 && selectedJobIds.includes(item.jobId) ? '0px' : '1px'} solid  ${item.isFromXyx || item.isExpire || item.isApply ? '#dfe1e8':  buttonColor}`}">
                <selected-svg :color="buttonColor" :fill="buttonColor" v-if="selectedJobIds.length > 0 && selectedJobIds.includes(item.jobId)"></selected-svg>
              </span>
            </div>
            <div class="job-body">
              <div class="c-top">
                <!-- 岗位名称 -->
                <div class="name van-ellipsis">
                  {{ item.jobName }}
                </div>
                <!-- 薪资 -->
                <div class="salary">
                  {{ item.provideSalaryString }}
                </div>
              </div>
              <div class="c-tags">
                <div class="c-tags-left">
                  <!-- 公司名称 -->
                  <div class="tag c-comname">
                    {{ item.companyName }}
                  </div>
                  <!-- 公司类型、公司规模 -->
                  <div class="tag type-string">
                    {{ item.companyTypeString }}
                  </div>
                </div>
                <div class="tag c-tags-right">
                  {{ item.companySizeString }}
                </div>
              </div>
              <div class="c-ope">
                <div class="c-bottom">
                    <div class="city-name van-ellipsis devs" v-if="item.jobTags && moduleStyle == 2">
                    {{ getTag(item.jobTags) }}
                  </div>
                  <div class="city-name van-ellipsis" v-if="item.jobAreaString && moduleStyle != 2">
                    {{ item.jobAreaString }}
                  </div>
                  <!--网申标识--> 
                  <!-- 引导按钮：buttonType    1-去聊聊   2-投递    3-不显示 -->
                  <div v-if="item.isFromXyx" class="xy">网申</div>
                </div>
                <div class="chatBtn"  @click.stop="gotoChat(item)" v-if="buttonTypeChat(item)">去聊聊</div>
                <div v-else-if="item.isApply" class="applyed">已投递</div>
                <div v-else-if="item.isExpire" class="applyed">已过期</div>
                <div
                  v-else-if="item.buttonType == 2 && ( (moduleStyle == 2 && item.isFromXyx) || moduleStyle != 2)"
                  class="apply"
                  @click.stop="gotoDeliver(item, index)"
                >
                  <img src="@/assets/img/activity/plane_16@3x.png" alt="" />
                  投递--{{item.isFromXyx}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { mapState, mapActions } from "vuex";
  import SelectedSvg from './SelectedSvg.vue'
  import Swiper from "swiper";
  import "swiper/css/swiper.min.css";
  export default {
    name: "SwiperContainerH5",
    components: { SelectedSvg },
    props: {
      componentConfig: {
        type: Object,
        default: () => {},
      },
      urgentJobList: {
        type: Array,
        default: () => [],
      },
      selectedJobIds: {
        type: Array,
        default: () => [],
      },
      buttonColor:{
        type: String,
        default:''
      },
      moduleStyle: {
        type: String,
        default: 1
      },
    },
    data() {
      return {
        mySwiper: null,
        keyRandom: Math.floor(100 + Math.random() * 900),
      };
    },
    computed: {
      ...mapState(["commonStore", "resumeStore"]),
      platform() {
        return this.commonStore.platform;
      },
    },
    mounted() {
      // this.initSwiper();
    },
    methods: {
      initSwiper() {
        let self = this;
        this.mySwiper = new Swiper(`.swiper-container-${this.keyRandom}`, {
          observer: true,
          observeParents: true,
          slidesPerView: "auto",
          slidesPerGroup: 1, //明确分组为1
          spaceBetween: 0,
          loop: false, // 禁用循环模式
          resistanceRatio: 0.8, //默认开启惯性弹性效果
          on: {
            touchStart: function (event) {
              if (event.changedTouches && event.changedTouches.length > 0) {
                // 记录触点开始位置
                self.touchStartX = event.changedTouches[0].pageX;
              }
              if (this.isEnd) {
                // if (!self.isLastTab) {
                //   this.params.resistanceRatio = 0.8; //开启惯性弹性效果
                //   this.update(); //更新swiper
                // } else {
                //   this.params.resistanceRatio = 0; //关闭惯性弹性效果
                //   this.update(); //更新swiper
                // }
              }
            },
            touchEnd: function (event) {
              if (event.changedTouches && event.changedTouches.length > 0) {
                // 记录触点结束位置
                self.touchEndX = event.changedTouches[0].pageX;
  
                // 判断是否滑动到最后一屏
                if (this.isEnd) {
                  // if (!self.isLastTab) {
                  //   // 查看下一专题文案展示埋点
                  //   self.$sensors.track("WidgetShow", {
                  //     $element_id: "sensor_25spring_hotandhaozhi_continueswipe",
                  //   });
                  //   // 计算滑动距离
                  //   const distance = self.touchStartX - self.touchEndX;
                  //   // 如果滑动距离超过 60px，执行跳转逻辑
                  //   if (distance > 60) {
                  //     self.viewMore(false);
                  //   }
                  // }
                }
              }
            },
          },
        });
      },
      ...mapActions("applyJobStore", ["applyJob", "batchApplyJob"]),
      clickJobCard(item, index) {
        this.$emit("clickJobCard", item, index);
      },
      buildJobShortExposureParams(item, index) {
        if (this.goodRank !== "") {
          return this.$base.getJobShortExposureParams(
            item,
            index,
            this.urgentJobList.length,
            {
              subContentRank: this.goodRank,
            }
          );
        } else {
          return this.$base.getJobShortExposureParams(
            item,
            index,
            this.urgentJobList.length
          );
        }
      },
      clickCompany(item, index) {
        this.$emit("clickCompany", item, index);
      },
      /**
       * 选中勾选框
       */
      onClickJobCheckbox(item) {
        this.$emit("onClickJobCheckbox", item);
      },
      gotoDeliver(item, index) {
        this.$emit("gotoDeliver", item, index);
      },
      gotoChat(item) {
        this.$emit("gotoChat", item);
      },
      welfare(jobTags) {
        return jobTags.join(",");
      },
      buttonTypeChat(item) {
        let platform = this.platform;
        let isApp = this.$store.getters.isApp;
        // TODO 测试删除
        // platform = "yjsApp"
        // isApp = true
        //
        if (isApp) {
          if (platform == "51jobApp") {
            // 51
            return item.buttonType == 1;
          } else if (platform == "yjsApp") {
            // yjs
            return item.isApply || item.buttonType == 1;
          }
        }
        return false;
      },
      getTag(tag){
        if(tag.length>0 ){
          return tag.join(',');
        }else {
          return '';
        }
      },
    },
  };
  </script>
  <style scoped lang="less">
    @import "./SwiperContainer.less";
  </style>